// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr } from "@revvsales/components";

// Components Imports
import { ChartHeader, StackedColumnChart } from "../Charts";
import DashboardLoader from "../DashboardLoader";

// Actions Imports
import DashboardActions from "../../../actions/DashboardActions";
import { getWonLostDealsData } from "../../../actions/DashboardActions/dashboardMethods";

// Internal Imports
import { DASHBOARD } from "../../../constants";
import { GlobalUtils } from "../../../utils";

// Destructuring
const { getDashboardDealValues } = DashboardActions;
const { MonthToDigitMap } = DASHBOARD;
const { handleApiErrMsg, numberForamting } = GlobalUtils;

class DealPerformance extends Component {
  state = { showLoader: false };

  componentDidMount() {
    this._onInitData();
  }

  _toggleLoader = flag => {
    this.setState({ showLoader: flag });
  };

  _onInitData = () => {
    const { apiConfigs: { userID, fromDate, toDate } = {} } = this.props;
    this._toggleLoader(true);
    this.props
      .getDashboardDealValues(userID, fromDate, toDate)
      .then(() => {
        this._toggleLoader(false);
      })
      .catch(error => {
        console.error(`DealPerformance(index.js) => _onInitData => ${error}`);
        this._toggleLoader(false);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _getChartCategories = categories =>
    categories.map(category => ({
      label: `${MonthToDigitMap[category.close_month]} ${category.close_year}`,
    }));

  // Chart Tool Text :: for showing the required data when hover on chart
  _getChartToolText = data => {
    let discountPer = 0;
    if (data.total_value !== 0) {
      discountPer = (data.total_discount / data.total_value) * 100;
    }
    return `
      <div class="chart-tooltext-wrapper">
        <div class="chart-tooltext-title">
          ${MonthToDigitMap[data.close_month]} ${data.close_year || ""}
        </div>
        <div class="chart-tooltext-row">
          <span class="chart-tooltext-row-title">Deal Size Closed </span> -  
          <span class="chart-tooltext-row-value primary-color">
            ${numberForamting(data.deal_value, "$")} 
          </span>
        </div>
        <div class="chart-tooltext-row">
          <span class="chart-tooltext-row-title">Total Discount Given  </span> -  
          <span class="chart-tooltext-row-value high-danger-color"> 
            ${numberForamting(data.total_discount, "$")}
          </span>
        </div>
        <div class="chart-tooltext-row">
          <span class="chart-tooltext-row-title">Discount Percentage </span> -
          <span class="chart-tooltext-row-value"> 
            ${discountPer && discountPer.toFixed(2)}%
          </span>
        </div>
      </div>
    `;
  };

  _getDealsizeDataSet = data => {
    const dealSizeDataSet = {
      seriesname: "Deal Size closed",
    };
    dealSizeDataSet.data = data.map(d => ({
      value: d.deal_value,
      tooltext: this._getChartToolText(d),
    }));
    return dealSizeDataSet;
  };

  _getDealDiscountDataSet = data => {
    const dealDiscountDataSet = {
      seriesname: "Total Discount Given",
    };
    dealDiscountDataSet.data = data.map(d => ({
      value: d.total_discount,
      tooltext: this._getChartToolText(d),
    }));
    return dealDiscountDataSet;
  };

  _getWonLostDealsTable = wonLostDeals =>
    wonLostDeals.map(data => (
      <div className="dealperformance-table-row">
        <div className="dealperformance-table-col table-col-icon">
          <FontAwesomeIcon icon={["fas", `${data.icon}`]} />
        </div>
        {data.col.map(colData => (
          <div className={`dealperformance-table-col ${colData.className}`}>
            <span
              className={`dealperformance-table-col-number ${
                colData.colorClassName
              }`}>
              {colData.value}
            </span>
            <span className="dealperformance-table-col-text">
              {colData.title}
            </span>
          </div>
        ))}

        {/* <div className="dealperformance-table-col dealperformance-table-col-iconwrapper ">
              <FontAwesomeIcon
                icon={["fas", "arrow-up"]}
                className="success-color"
              />
              <span className="dealperformance-table-col-percentage success-color">
                3%
              </span>
            </div> */}
      </div>
    ));

  _decideView = () => {
    const {
      chartWidth,
      chartHeight,
      dealValuesByMonths,
      lostDeals,
      wonDeals,
    } = this.props;

    const chartConfig = {
      chart: {
        caption: "Deal Discount Guidance",
      },
      categories: [
        {
          category: this._getChartCategories(dealValuesByMonths || []),
        },
      ],
      dataset: [
        { ...this._getDealsizeDataSet(dealValuesByMonths || []) },
        { ...this._getDealDiscountDataSet(dealValuesByMonths || []) },
      ],
    };

    const wonLostDeals = getWonLostDealsData(wonDeals, lostDeals);

    return (
      <div className="dealperformance-container">
        {/* ----- Header Section ------- */}
        <ChartHeader
          title="Deal Performance"
          dateTitle="Jan 01, 2019 July 01, 2019"
        />

        <div className="dealperformance-chart-wrapper">
          {/* ----- Deal Performance Table Section ------- */}
          <div className="dealperformance-table-wrapper">
            {this._getWonLostDealsTable(wonLostDeals)}
          </div>

          {/* ----- Deal Performance Stacked Column Chart Section ------- */}
          <div className="dealperformance-columnchart-wrapper">
            <StackedColumnChart
              width={chartWidth}
              height={chartHeight}
              configs={chartConfig}
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    if (this.state.showLoader) {
      return <DashboardLoader message="loading deals values" />;
    }
    return <Fragment>{this._decideView()}</Fragment>;
  }
}

const mapStateToProps = state => {
  const { dealValuesByMonths, wonDeals, lostDeals } = state.DashboardStore;
  return { dealValuesByMonths, wonDeals, lostDeals };
};

const mapDispatchToProps = {
  getDashboardDealValues: (userID, fromDate, toDate) =>
    getDashboardDealValues(userID, fromDate, toDate),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DealPerformance);



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/DealPerformance/index.js